export class InvoiceDeductionDetail {
  public AmountProvisionedTaxExcluded: number | null;
  public AmountReleasedTaxExcluded: number | null;
  public AmountRetainedTaxExcluded: number | null;
  public Code: string | null;
  public Label: string | null;
  public CreatedAt: number;
  public Id: string | null;
  public InvoiceId: string | null;
  public Percentage?: number | null;
  }
